/*
 * Código de vendedor SALEM.
 * Si el cliente entra con ?vendedor=CODIGO, el código se recuerda 30 días y se guarda en el carrito
 * como atributo "vendedor". Shopify lo pasa al pedido y el ERP le asigna la venta a ese vendedor.
 */
(function () {
  var KEY = 'salem_vendedor';
  var DAYS = 30;
  var VALID = /^[A-Za-z0-9]{4,15}$/;

  function read() {
    try {
      var saved = JSON.parse(localStorage.getItem(KEY) || 'null');
      if (saved && VALID.test(saved.code) && saved.exp > Date.now()) return saved.code;
    } catch (e) {}
    return null;
  }

  function save(code) {
    try {
      localStorage.setItem(KEY, JSON.stringify({ code: code, exp: Date.now() + DAYS * 86400000 }));
    } catch (e) {}
  }

  var fromUrl = new URLSearchParams(window.location.search).get('vendedor');
  if (fromUrl && VALID.test(fromUrl)) save(fromUrl.toUpperCase());

  var code = read();
  if (!code) return;

  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  fetch(root + 'cart.js', { credentials: 'same-origin' })
    .then(function (r) { return r.json(); })
    .then(function (cart) {
      if (cart && cart.attributes && cart.attributes.vendedor === code) return;
      return fetch(root + 'cart/update.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ attributes: { vendedor: code } }),
      });
    })
    .catch(function () {});
})();
